import * as React from 'react';
import styled from 'styled-components';

import { Button, Step, StepLabel, StepContent } from '../material-ui';
import styleObject from '../style-object';

const ButtonWrapper = styled.div`
	margin: 1rem 0 0.5rem 0;
`;

const backButtonStyle = styleObject`
	margin-right: 1rem;
`;

export class StepperSection extends React.Component {
	handleLabelClicked = () => this.props.onSetPosition(this.props.position);
	handleGoBack = () => this.props.onSetPosition(this.props.position - 1);
	handleGoForward = () => this.props.onSetPosition(this.props.position + 1);

	render = () => {
		// eslint-disable-next-line no-unused-vars
		const { onSetPosition, label, children, ...props } = this.props;
		return (
			<Step {...props}>
				<StepLabel onClick={this.handleLabelClicked}>{label}</StepLabel>
				<StepContent>
					{children}
					<ButtonWrapper>
						<Button onClick={this.handleGoBack} style={backButtonStyle}>
							Zurück
						</Button>
						<Button variant="contained" color="primary" onClick={this.handleGoForward}>
							Weiter
						</Button>
					</ButtonWrapper>
				</StepContent>
			</Step>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/StepperSection.js